import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=69486b28"
import script from "./sub.vue?vue&type=script&lang=js"
export * from "./sub.vue?vue&type=script&lang=js"
import style0 from "./sub.vue?vue&type=style&index=0&id=69486b28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports